import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { analytics } from '@/lib/analytics'
import { isPageViewBlacklisted, resolvePathname } from '@/lib/analytics/pageContext'

// Central page-view tracker, mounted once at the router root. Fires a single `page_viewed`
// on every path change — the effect depends on `pathname` only, so query/hash-only changes
// don't retrigger it — tagged with the route's page_type (via the enrichment plugin),
// unless that page type is on the blacklist. This replaces the old per-page
// `analytics.trackPageView` calls; the raw URL is never built or sent.
export function RouteAnalytics() {
  const { pathname } = useLocation()

  useEffect(() => {
    const { pageType } = resolvePathname(pathname)
    if (pageType && !isPageViewBlacklisted(pageType)) {
      analytics.trackPageView({ page_type: pageType })
    }
  }, [pathname])

  return null
}
